export default __webpack_public_path__ + "static/media/a4-printer_en.f8abdc57.png";